import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import AppLayout from '@/components/layout/AppLayout';
import { ProfileSection } from './account/ProfileSection';
import { EmailSection } from './account/EmailSection';
import { PasswordSection } from './account/PasswordSection';
import { AiUsageSection } from './account/AiUsageSection';

export default function AccountSettingsPage() {
  const { user, checkAuth } = useAuth();

  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto p-6 sm:p-8" data-testid="account-settings-page">
        <h1 className="font-outfit text-3xl font-bold text-[#09090B] mb-8">Account Settings</h1>
        <div className="space-y-6">
          <ProfileSection user={user} checkAuth={checkAuth} />
          <EmailSection user={user} checkAuth={checkAuth} />
          <PasswordSection />
          <AiUsageSection />
        </div>
      </div>
    </AppLayout>
  );
}
